(function () {
  'use strict';
  if (window.szVerlanglijstGeladen) return;
  window.szVerlanglijstGeladen = true;

  var SLEUTEL = 'sz-verlanglijst';
  var MAX = 100;
  var cfg = window.szVerlanglijst || {};
  var root = cfg.root || '/';
  var paginaUrl = cfg.pagina || '/pages/verlanglijst';
  var geheugen = null;


  function lees() {
    if (geheugen) return geheugen.slice();
    try {
      var lijst = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
      if (!Array.isArray(lijst)) return [];
      return lijst.filter(function (x) { return x && typeof x.h === 'string' && x.h; });
    } catch (e) {
      return [];
    }
  }

  function handles() {
    return lees().map(function (x) { return x.h; });
  }

  function bewaar(lijst) {
    lijst = lijst.slice(0, MAX);
    try {
      localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
      geheugen = null;
    } catch (e) {
      geheugen = lijst;
    }
    gewijzigd();
  }

  function gewijzigd() {
    werkBij();
    document.dispatchEvent(new CustomEvent('verlanglijst:gewijzigd', { detail: { handles: handles() } }));
  }

  function voegToe(handle) {
    var lijst = lees().filter(function (x) { return x.h !== handle; });
    lijst.unshift({ h: handle, t: Date.now() });
    bewaar(lijst);
  }

  function haalWeg(handle) {
    bewaar(lees().filter(function (x) { return x.h !== handle; }));
  }


  var onderweg = 0;

  function werkBij() {
    var lijst = handles();
    var knoppen = document.querySelectorAll('[data-vl-knop]');
    for (var i = 0; i < knoppen.length; i++) {
      var knop = knoppen[i];
      var aan = lijst.indexOf(knop.getAttribute('data-handle')) !== -1;
      knop.classList.toggle('is-bewaard', aan);
      knop.setAttribute('aria-pressed', aan ? 'true' : 'false');
      var tekst = knop.querySelector('[data-vl-tekst]');
      if (tekst) tekst.textContent = aan ? 'Bewaard op verlanglijst' : 'Bewaar op verlanglijst';
    }
    if (!onderweg) werkTellersBij();
  }

  function werkTellersBij() {
    var lijst = handles();
    var tellers = document.querySelectorAll('[data-vl-teller]');
    for (var j = 0; j < tellers.length; j++) {
      tellers[j].textContent = lijst.length > 99 ? '99+' : String(lijst.length);
      tellers[j].hidden = lijst.length === 0;
    }
  }

  function inBeeld(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function zichtbareKop() {
    var koppen = document.querySelectorAll('.vl-kop');
    for (var i = 0; i < koppen.length; i++) {
      if (inBeeld(koppen[i])) return koppen[i];
    }
    return null;
  }

  function zonderBeweging() {
    return !document.body.animate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  var HART = '<path d="M12 20.3l-1.2-1.1C6.3 15.1 3.3 12.4 3.3 9.1 3.3 6.4 5.4 4.3 8.1 4.3c1.5 0 3 .7 3.9 1.8.9-1.1 2.4-1.8 3.9-1.8 2.7 0 4.8 2.1 4.8 4.8 0 3.3-3 6-7.5 10.1L12 20.3z"/>';
  var zwevers = {};
  var zweefWeg = {};

  function tijdelijkDoel(soort, echte, icoon, aantal, tellerAttr) {
    clearTimeout(zweefWeg[soort]);
    var z = zwevers[soort];
    if (z && z.parentNode) return z;
    var r = echte ? echte.getBoundingClientRect() : null;
    var midden = r && r.width ? r.left + r.width / 2 : window.innerWidth - 38;
    z = document.createElement('div');
    z.className = 'vl-zweef vl-zweef--' + soort;
    z.setAttribute('aria-hidden', 'true');
    z.style.left = Math.round(Math.min(Math.max(midden, 30), window.innerWidth - 30) - 22) + 'px';
    z.innerHTML = icoon + '<span class="vl-zweef__teller" ' + tellerAttr + (aantal ? '' : ' hidden') + '>' + (aantal > 99 ? '99+' : aantal) + '</span>';
    document.body.appendChild(z);
    void z.offsetWidth;
    z.classList.add('is-zichtbaar');
    zwevers[soort] = z;
    return z;
  }

  function ruimZweefOp(z) {
    Object.keys(zwevers).forEach(function (soort) {
      if (zwevers[soort] !== z) return;
      clearTimeout(zweefWeg[soort]);
      zweefWeg[soort] = setTimeout(function () {
        z.classList.remove('is-zichtbaar');
        setTimeout(function () {
          if (z.parentNode) z.parentNode.removeChild(z);
          if (zwevers[soort] === z) zwevers[soort] = null;
        }, 250);
      }, 900);
    });
  }

  function boog(a, b, inhoud, o) {
    var maat = o.maat;
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2;
    var dx = b.left + b.width / 2 - x0, dy = b.top + b.height / 2 - y0;
    var x = document.createElement('div'), y = document.createElement('div'), s = document.createElement('div');
    x.className = 'vl-vlieg' + (o.klasse ? ' ' + o.klasse : '');
    x.style.cssText = 'left:' + (x0 - maat / 2) + 'px;top:' + (y0 - maat / 2) + 'px;width:' + maat + 'px;height:' + maat + 'px';
    y.className = s.className = 'vl-vlieg-laag';
    if (typeof inhoud === 'string') s.innerHTML = inhoud; else s.appendChild(inhoud);
    y.appendChild(s); x.appendChild(y); document.body.appendChild(x);

    var duur = o.duur || 780;
    x.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], { duration: duur, easing: 'cubic-bezier(.55,0,.85,.45)', fill: 'forwards' });
    y.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(' + dy + 'px)' }], { duration: duur, easing: 'cubic-bezier(.15,.6,.35,1)', fill: 'forwards' });
    var krimp = s.animate([
      { transform: 'scale(1)', opacity: 1, offset: 0 },
      { transform: 'scale(' + o.piek + ')', opacity: 1, offset: o.piekOp || 0.15 },
      { transform: 'scale(' + (o.eind / maat) + ')', opacity: o.eindDekking || 1, offset: 1 }
    ], { duration: duur, easing: 'cubic-bezier(.45,0,.9,.55)', fill: 'forwards' });

    return new Promise(function (klaar) {
      var gemeld = false;
      function weg() {
        if (gemeld) return;
        gemeld = true;
        if (x.parentNode) x.parentNode.removeChild(x);
        klaar();
      }
      krimp.onfinish = weg;
      setTimeout(weg, duur + 500);
    });
  }

  function vlieg(knop) {
    if (zonderBeweging() || !document.querySelector('.vl-kop')) return Promise.resolve(null);
    var bron = knop.querySelector('.vl-hart') || knop;
    var a = bron.getBoundingClientRect();
    if (!a.width) return Promise.resolve(null);
    var kop = zichtbareKop() || tijdelijkDoel('hart', document.querySelector('.vl-kop'),
      '<svg class="vl-kop__hart" viewBox="0 0 24 24" focusable="false">' + HART + '</svg>',
      Math.max(0, handles().length - 1), 'data-vl-teller');
    var b = (kop.querySelector('.vl-kop__hart') || kop).getBoundingClientRect();
    if (!b.width) return Promise.resolve(null);
    return boog(a, b, '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + HART + '</svg>', {
      maat: Math.max(a.width, a.height, 18),
      eind: Math.max(b.width, b.height),
      piek: 1.5
    }).then(function () { return kop; });
  }

  function land(doel) {
    doel.classList.remove('vl-land');
    void doel.offsetWidth;
    doel.classList.add('vl-land');
    setTimeout(function () { doel.classList.remove('vl-land'); }, 650);
    ruimZweefOp(doel);
  }

  function meet(knop) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    var prijs = parseFloat(knop.getAttribute('data-prijs')) || 0;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: cfg.valuta || 'EUR',
        value: prijs,
        items: [{
          item_id: knop.getAttribute('data-id'),
          item_name: knop.getAttribute('data-titel'),
          item_brand: knop.getAttribute('data-merk'),
          price: prijs,
          quantity: 1
        }]
      }
    });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-vl-knop]') : null;
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = knop.getAttribute('data-handle');
    if (!handle) return;
    if (handles().indexOf(handle) !== -1) {
      haalWeg(handle);
    } else {
      onderweg++;
      voegToe(handle);
      vlieg(knop).then(function (kop) {
        onderweg = Math.max(0, onderweg - 1);
        werkTellersBij();
        if (kop) land(kop);
      });
      meet(knop);
      knop.classList.remove('vl-pop');
      void knop.offsetWidth;
      knop.classList.add('vl-pop');
      setTimeout(function () { knop.classList.remove('vl-pop'); }, 400);
      document.dispatchEvent(new CustomEvent('verlanglijst:toegevoegd', { detail: { knop: knop, handle: handle } }));
    }
  }, true);

  function bevatKnop(node) {
    return node.nodeType === 1 && (
      node.matches('[data-vl-knop],[data-vl-teller]') ||
      node.querySelector('[data-vl-knop],[data-vl-teller]') !== null
    );
  }
  var gepland = false;
  new MutationObserver(function (mutaties) {
    if (gepland) return;
    for (var i = 0; i < mutaties.length; i++) {
      var nodes = mutaties[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (bevatKnop(nodes[j])) {
          gepland = true;
          setTimeout(function () { gepland = false; werkBij(); }, 0);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('storage', function (e) {
    if (e.key === SLEUTEL) gewijzigd();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) werkBij();
  });

  werkBij();


  var pagina = document.querySelector('[data-vl-pagina]');
  if (!pagina) return;

  var raster = pagina.querySelector('[data-vl-lijst]');
  var leeg = pagina.querySelector('[data-vl-leeg]');
  var laden = pagina.querySelector('[data-vl-laden]');
  var deelKnop = pagina.querySelector('[data-vl-deel]');
  var overneemKnop = pagina.querySelector('[data-vl-overnemen]');
  var melding = pagina.querySelector('[data-vl-melding]');
  var titel = pagina.querySelector('[data-vl-titel]');
  var intro = pagina.querySelector('[data-vl-intro]');
  var allesKnop = pagina.querySelector('[data-vl-alles]');
  var wisKnop = pagina.querySelector('[data-vl-wis]');
  var ongedaan = pagina.querySelector('[data-vl-ongedaan]');
  var herstelKnop = pagina.querySelector('[data-vl-herstel]');
  var vorigeLijst = null;

  var gedeeldeVarianten = {};
  var gedeeld = gedeeldeLijst();
  var eigen = gedeeld === null;
  var getoond = [];
  var bezig = {};
  var mislukt = {};

  function gedeeldeLijst() {
    var waarde = new URLSearchParams(window.location.search).get('lijst');
    if (waarde === null) return null;
    var gezien = {};
    return waarde.split(',')
      .map(function (stuk) {
        var delen = stuk.trim().split('~');
        if (delen[1] && /^\d+$/.test(delen[1])) gedeeldeVarianten[delen[0]] = Number(delen[1]);
        return delen[0];
      })
      .filter(function (h) {
        if (!h || h.length > 255 || /[\s\/?#]/.test(h) || gezien[h]) return false;
        gezien[h] = true;
        return true;
      })
      .slice(0, MAX);
  }

  function meld(tekst, fout) {
    if (!melding) return;
    melding.textContent = tekst;
    melding.hidden = !tekst;
    melding.classList.toggle('is-fout', !!fout);
  }

  function toonLeeg(aan) {
    leeg.hidden = !aan;
    raster.hidden = aan;
    if (deelKnop) deelKnop.hidden = aan || !eigen;
    if (overneemKnop) overneemKnop.hidden = aan || eigen;
    if (wisKnop) wisKnop.hidden = aan || !eigen;
    werkAllesKnopBij();
  }

  function haalKaart(handle) {
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=verlanglijst-kaart';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) return { handle: handle, weg: true };
        if (!r.ok) return { handle: handle, fout: true };
        return r.text().then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var kolom = tmp.querySelector('[data-vl-kolom]');
          if (!kolom) return { handle: handle, weg: true };
          return { handle: handle, echt: kolom.getAttribute('data-vl-kolom'), kolom: kolom };
        });
      })
      .catch(function () { return { handle: handle, fout: true }; });
  }

  function haalAlles(lijst) {
    var uitkomst = new Array(lijst.length);
    var volgende = 0;
    function werker() {
      if (volgende >= lijst.length) return Promise.resolve();
      var i = volgende++;
      return haalKaart(lijst[i]).then(function (r) { uitkomst[i] = r; return werker(); });
    }
    var werkers = [];
    for (var w = 0; w < Math.min(6, lijst.length); w++) werkers.push(werker());
    return Promise.all(werkers).then(function () { return uitkomst; });
  }

  function maakZichtbaar(kolommen) {
    var beelden = [];
    kolommen.forEach(function (k) {
      beelden = beelden.concat(Array.prototype.slice.call(k.querySelectorAll('.product-card--image-primary')));
    });
    if (!beelden.length) return;
    if (window.gsap && document.body.classList.contains('animations-true')) {
      var easing = (window.theme && window.theme.settings && window.theme.settings.animation_easing) || 'power1.out';
      window.gsap.to(beelden, { scale: 1, opacity: 1, stagger: 0.08, ease: easing });
    } else {
      beelden.forEach(function (b) { b.style.opacity = '1'; b.style.transform = 'none'; });
    }
  }

  function laad(lijst, vooraan) {
    lijst = lijst.filter(function (h) { return !bezig[h]; });
    if (!lijst.length) return Promise.resolve();
    lijst.forEach(function (h) { bezig[h] = true; });

    return haalAlles(lijst).then(function (uitkomst) {
      var nieuw = [];
      var opslag = eigen ? lees() : null;
      var opslagGewijzigd = false;
      var fouten = 0;

      uitkomst.forEach(function (r) {
        delete bezig[r.handle];
        if (r.fout) {
          mislukt[r.handle] = true;
          fouten++;
          return;
        }
        if (r.weg) {
          if (opslag) {
            opslag = opslag.filter(function (x) { return x.h !== r.handle; });
            opslagGewijzigd = true;
          }
          return;
        }
        var echt = r.echt || r.handle;
        if (echt !== r.handle && opslag) {
          var alBewaard = opslag.some(function (x) { return x.h === echt; });
          opslag = alBewaard
            ? opslag.filter(function (x) { return x.h !== r.handle; })
            : opslag.map(function (x) { return x.h === r.handle ? { h: echt, t: x.t, v: x.v } : x; });
          opslagGewijzigd = true;
        }
        if (getoond.indexOf(echt) !== -1) return;
        getoond.push(echt);
        nieuw.push(r.kolom);
      });

      if (vooraan) {
        nieuw.slice().reverse().forEach(function (k) { raster.insertBefore(k, raster.firstChild); });
      } else {
        nieuw.forEach(function (k) { raster.appendChild(k); });
      }

      if (opslagGewijzigd) bewaar(opslag);

      nieuw.forEach(function (k) {
        var koop = k.querySelector('[data-vl-koop]');
        if (koop) vulVooraf(koop, k.getAttribute('data-vl-kolom'));
      });

      if (laden) laden.hidden = true;
      toonLeeg(getoond.length === 0);
      maakZichtbaar(nieuw);
      werkBij();
      meld(fouten ? 'Niet alle producten konden worden geladen. Probeer het straks nog eens.' : '', !!fouten);
    });
  }

  function verwijderKolom(kolom) {
    kolom.style.transition = 'opacity .25s ease';
    kolom.style.opacity = '0';
    setTimeout(function () {
      if (kolom.parentNode) kolom.parentNode.removeChild(kolom);
      werkAllesKnopBij();
    }, 260);
  }

  function kopieer(tekst) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(tekst);
    return Promise.reject(new Error('geen klembord'));
  }


  var MAAT_SLEUTEL = 'sz-verlanglijst-maat';
  var allesVraag = '';

  function leesMaat() {
    try { return localStorage.getItem(MAAT_SLEUTEL) || ''; } catch (e) { return ''; }
  }

  function bewaarMaat(maat) {
    try { localStorage.setItem(MAAT_SLEUTEL, maat); } catch (e) {}
  }

  function koopData(koop) {
    if (!koop._vl) {
      var json = koop.querySelector('[data-vl-varianten]');
      var varianten = [];
      try { varianten = JSON.parse(json ? json.textContent : '[]'); } catch (e) {}
      koop._vl = {
        varianten: varianten,
        keuzes: Array.prototype.slice.call(koop.querySelectorAll('[data-vl-optie]'))
      };
    }
    return koop._vl;
  }

  function index(keuze) {
    return parseInt(keuze.getAttribute('data-vl-optie'), 10);
  }

  function isMaat(keuze) {
    return keuze.getAttribute('data-maat') === 'true';
  }

  function heeftWaarde(keuze, waarde) {
    if (!waarde) return false;
    for (var i = 0; i < keuze.options.length; i++) {
      if (keuze.options[i].value === waarde) return true;
    }
    return false;
  }

  function zoekVariant(d, id) {
    for (var i = 0; i < d.varianten.length; i++) {
      if (String(d.varianten[i].id) === String(id)) return d.varianten[i];
    }
    return null;
  }

  function gekozen(koop) {
    var d = koopData(koop);
    for (var i = 0; i < d.keuzes.length; i++) {
      if (d.keuzes[i].value === '') return null;
    }
    for (var j = 0; j < d.varianten.length; j++) {
      var v = d.varianten[j];
      var past = d.keuzes.every(function (k) { return v.o[index(k)] === k.value; });
      if (past) return v;
    }
    return d.varianten.length === 1 && !d.keuzes.length ? d.varianten[0] : false;
  }

  function kolomVan(koop) {
    return koop.closest('[data-vl-kolom]');
  }

  function koopMelding(koop, tekst) {
    var p = koop.querySelector('[data-vl-koop-melding]');
    if (!p) return;
    p.textContent = tekst;
    p.hidden = !tekst;
  }

  function werkKoopBij(koop) {
    var d = koopData(koop);
    var knop = koop.querySelector('[data-vl-in-wagen]');

    d.keuzes.forEach(function (keuze) {
      var i = index(keuze);
      Array.prototype.forEach.call(keuze.options, function (optie) {
        if (!optie.value) return;
        var passend = d.varianten.filter(function (v) {
          if (v.o[i] !== optie.value) return false;
          return d.keuzes.every(function (ander) {
            return ander === keuze || ander.value === '' || v.o[index(ander)] === ander.value;
          });
        });
        var op = passend.length > 0 && !passend.some(function (v) { return v.a; });
        optie.disabled = passend.length === 0;
        optie.textContent = optie.value + (op ? ' (uitverkocht)' : '');
      });
    });

    if (!knop || knop.classList.contains('is-bezig')) return;
    if (koop.getAttribute('data-beschikbaar') !== 'true') {
      knop.disabled = true;
      knop.textContent = 'Uitverkocht';
      return;
    }
    var v = gekozen(koop);
    if (v === false) {
      knop.disabled = true;
      knop.textContent = 'Niet leverbaar';
    } else if (v && !v.a) {
      knop.disabled = true;
      knop.textContent = 'Uitverkocht';
    } else {
      knop.disabled = false;
      knop.textContent = 'In winkelwagen';
    }
  }

  function toonKleur(koop) {
    var stalen = kolomVan(koop).querySelector('.product-card-swatches');
    if (!stalen) return;
    var keuze = koop.querySelector('[data-vl-optie="' + stalen.getAttribute('data-index') + '"]');
    if (!keuze || !keuze.value) return;
    var invoer = stalen.querySelectorAll('.product-card-swatch-input');
    for (var i = 0; i < invoer.length; i++) {
      if (invoer[i].value.toLowerCase() === keuze.value.toLowerCase()) {
        invoer[i].checked = true;
        invoer[i].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function bewaarKeuze(koop) {
    var handle = kolomVan(koop).getAttribute('data-vl-kolom');
    var v = gekozen(koop);
    var id = v ? v.id : null;
    if (!eigen) {
      if (id) gedeeldeVarianten[handle] = id; else delete gedeeldeVarianten[handle];
      return;
    }
    var lijst = lees();
    var anders = false;
    lijst.forEach(function (x) {
      if (x.h !== handle || (x.v || null) === id) return;
      if (id) x.v = id; else delete x.v;
      anders = true;
    });
    if (anders) bewaar(lijst);
  }

  function vulVooraf(koop, handle) {
    var d = koopData(koop);
    if (d.keuzes.length) {
      var eerder = null;
      if (eigen) {
        lees().forEach(function (x) { if (x.h === handle && x.v) eerder = x.v; });
      } else {
        eerder = gedeeldeVarianten[handle] || null;
      }
      var bron = eerder ? zoekVariant(d, eerder) : null;
      var standaard = zoekVariant(d, koop.getAttribute('data-standaard'));
      var maat = leesMaat();
      var maatUitGeheugen = false;

      d.keuzes.forEach(function (keuze) {
        var i = index(keuze);
        var waarde = '';
        if (bron) {
          waarde = bron.o[i];
        } else if (isMaat(keuze)) {
          waarde = maat;
          maatUitGeheugen = true;
        } else if (standaard) {
          waarde = standaard.o[i];
        }
        keuze.value = heeftWaarde(keuze, waarde) ? waarde : '';
      });

      var v = gekozen(koop);
      if (maatUitGeheugen && (v === false || (v && !v.a))) {
        d.keuzes.forEach(function (keuze) { if (isMaat(keuze)) keuze.value = ''; });
      }
    }
    werkKoopBij(koop);
    toonKleur(koop);
  }

  function deelMaat(bronKoop, maat) {
    Array.prototype.forEach.call(raster.querySelectorAll('[data-vl-koop]'), function (koop) {
      if (koop === bronKoop) return;
      var d = koopData(koop);
      var keuze = d.keuzes.filter(isMaat)[0];
      if (!keuze || keuze.value !== '' || keuze.disabled || !heeftWaarde(keuze, maat)) return;
      keuze.value = maat;
      var v = gekozen(koop);
      if (v === false || (v && !v.a)) {
        keuze.value = '';
        return;
      }
      keuze.classList.remove('is-fout');
      koopMelding(koop, '');
      werkKoopBij(koop);
      bewaarKeuze(koop);
    });
  }

  function markeerOntbrekend(koop) {
    var leeg = koopData(koop).keuzes.filter(function (k) { return k.value === ''; });
    leeg.forEach(function (k) { k.classList.add('is-fout'); });
    return leeg;
  }

  function sectiesVoorWagen(kaart) {
    if (kaart && typeof kaart.getSectionsToRender === 'function') {
      return kaart.getSectionsToRender().map(function (s) { return s.section; });
    }
    return ['cart-drawer', 'cart-bubble'];
  }

  function vertrekpunt(r) {
    return r && r.width > 0 && r.bottom > 80 && r.top < window.innerHeight;
  }

  function aantalInMand() {
    var tel = document.querySelector('#cart-drawer-toggle .thb-item-count');
    return tel ? parseInt(tel.textContent, 10) || 0 : 0;
  }

  function vliegFoto(koop, knop) {
    var mand = document.getElementById('cart-drawer-toggle');
    if (zonderBeweging() || !mand) return Promise.resolve(null);
    var kolom = kolomVan(koop);
    var foto = kolom.querySelector('.product-primary-image') || kolom.querySelector('product-card img');
    if (!foto || !(foto.currentSrc || foto.src)) return Promise.resolve(null);
    var a = foto.getBoundingClientRect();
    if (!vertrekpunt(a)) a = knop.getBoundingClientRect();
    var icoon = mand.querySelector('svg');
    var doel = inBeeld(mand) ? mand : tijdelijkDoel('mand', mand, icoon ? icoon.outerHTML : '', aantalInMand(), 'data-vl-mandteller');
    if (!vertrekpunt(a)) return Promise.resolve(doel);
    var b = (doel.querySelector('svg') || doel).getBoundingClientRect();
    if (!b.width) return Promise.resolve(null);
    var img = document.createElement('img');
    img.src = foto.currentSrc || foto.src;
    img.alt = '';
    return boog(a, b, img, {
      maat: Math.max(56, Math.min(a.width, a.height, 200)),
      eind: 22,
      piek: 1.07,
      piekOp: 0.12,
      eindDekking: 0.85,
      klasse: 'vl-vlieg--foto',
      duur: 820
    }).then(function () { return doel; });
  }

  function verversMandje(data) {
    var delen = [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
    var gelukt = false;
    if (data && data.sections) {
      delen.forEach(function (d) {
        var plek = document.getElementById(d.id);
        var html = data.sections[d.section];
        if (!plek || !html) return;
        var nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector(d.selector);
        var doel = plek.querySelector(d.selector) || plek;
        if (nieuw) {
          doel.innerHTML = nieuw.innerHTML;
          gelukt = true;
        }
      });
    }
    var lade = document.getElementById('Cart-Drawer');
    if (lade) {
      try {
        if (lade.notesToggle) lade.notesToggle();
        if (lade.removeProductEvent) lade.removeProductEvent();
      } catch (e) {}
    }
    if (!gelukt) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var zweefTeller = zwevers.mand && zwevers.mand.querySelector('[data-vl-mandteller]');
    if (zweefTeller) {
      var n = aantalInMand();
      zweefTeller.textContent = n > 99 ? '99+' : String(n);
      zweefTeller.hidden = !n;
    }
    if (typeof window.dispatchCustomEvent === 'function') {
      window.dispatchCustomEvent('cart:item-added', { product: data && data.items ? data.items[0] : data });
    }
  }

  function naarWagen(items, stil) {
    var kaart = raster.querySelector('product-card');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: items,
        sections: sectiesVoorWagen(kaart).join(','),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    }).then(function (data) {
      if (stil) return data;
      var getoondInPaneel = false;
      if (kaart && typeof kaart.renderContents === 'function' && data.sections) {
        try { kaart.renderContents(data); getoondInPaneel = true; } catch (e) {}
      }
      if (!getoondInPaneel) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof window.dispatchCustomEvent === 'function') {
        window.dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
      }
      return data;
    });
  }

  function foutTekst(fout) {
    return (fout && (fout.description || fout.message)) || 'Dat lukte niet. Probeer het nog eens.';
  }

  function knopBezig(knop, tekst) {
    knop.classList.add('is-bezig');
    knop.setAttribute('aria-busy', 'true');
    knop.textContent = tekst;
  }

  function knopKlaar(knop, tekst, daarna) {
    knop.classList.remove('is-bezig');
    knop.removeAttribute('aria-busy');
    knop.textContent = tekst;
    setTimeout(daarna, 2200);
  }

  pagina.addEventListener('change', function (e) {
    var keuze = e.target && e.target.closest ? e.target.closest('[data-vl-optie]') : null;
    if (!keuze) return;
    var koop = keuze.closest('[data-vl-koop]');
    keuze.classList.remove('is-fout');
    koopMelding(koop, '');
    werkKoopBij(koop);
    bewaarKeuze(koop);
    if (isMaat(keuze)) {
      if (keuze.value) {
        bewaarMaat(keuze.value);
        deelMaat(koop, keuze.value);
      }
    } else {
      toonKleur(koop);
    }
    if (melding && melding.classList.contains('is-fout') && allesVraag) {
      var open = Array.prototype.filter.call(raster.querySelectorAll('[data-vl-koop]'), function (k) {
        return k.querySelector('.vl-koop__keuze.is-fout');
      }).length;
      if (open) meld(allesVraag + aantal(open) + '.', true);
      else { meld(''); allesVraag = ''; }
    }
  });

  pagina.addEventListener('click', function (e) {
    var staal = e.target && e.target.closest ? e.target.closest('[data-vl-kolom] .product-card-swatch') : null;
    if (!staal) return;
    var koop = kolomVan(staal).querySelector('[data-vl-koop]');
    var stalen = staal.closest('.product-card-swatches');
    var invoer = staal.previousElementSibling;
    var keuze = koop && stalen ? koop.querySelector('[data-vl-optie="' + stalen.getAttribute('data-index') + '"]') : null;
    if (!keuze || keuze.disabled || !invoer) return;
    var waarde = '';
    Array.prototype.forEach.call(keuze.options, function (o) {
      if (o.value && o.value.toLowerCase() === invoer.value.toLowerCase()) waarde = o.value;
    });
    if (!waarde) return;
    e.preventDefault();
    e.stopPropagation();
    keuze.value = waarde;
    keuze.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  pagina.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-vl-in-wagen]') : null;
    if (!knop || knop.disabled || knop.classList.contains('is-bezig')) return;
    var koop = knop.closest('[data-vl-koop]');
    var v = gekozen(koop);
    if (!v) {
      var leeg = markeerOntbrekend(koop);
      if (leeg[0]) leeg[0].focus();
      return;
    }
    koopMelding(koop, '');
    knopBezig(knop, 'Bezig...');
    naarWagen([{ id: v.id, quantity: 1 }], true).then(function (data) {
      knopKlaar(knop, 'Toegevoegd', function () { werkKoopBij(koop); });
      return vliegFoto(koop, knop).then(function (doel) {
        verversMandje(data);
        if (doel) land(doel);
      });
    }, function (fout) {
      knop.classList.remove('is-bezig');
      knop.removeAttribute('aria-busy');
      werkKoopBij(koop);
      koopMelding(koop, foutTekst(fout));
    });
  });

  function zichtbareKopers() {
    return Array.prototype.filter.call(raster.querySelectorAll('[data-vl-koop]'), function (koop) {
      return kolomVan(koop).style.opacity !== '0';
    });
  }

  function werkAllesKnopBij() {
    if (!allesKnop) return;
    allesKnop.hidden = raster.hidden || !zichtbareKopers().some(function (koop) {
      return koop.getAttribute('data-beschikbaar') === 'true';
    });
  }

  function aantal(n) {
    return n + (n === 1 ? ' product' : ' producten');
  }

  function eenVoorEen(items, kopers) {
    var gelukt = [];
    var fouten = [];
    var laatste = null;
    return items.reduce(function (keten, item, i) {
      return keten.then(function () {
        return naarWagen([item], true).then(function (data) {
          gelukt.push(kopers[i]);
          laatste = data;
        }, function (fout) { fouten.push(foutTekst(fout)); });
      });
    }, Promise.resolve()).then(function () {
      return { kopers: gelukt, fouten: fouten, data: laatste };
    });
  }

  function zetMandTeller(n) {
    var tekst = n > 99 ? '99+' : String(n);
    var tel = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (tel) tel.textContent = tekst;
    var zweefTeller = zwevers.mand && zwevers.mand.querySelector('[data-vl-mandteller]');
    if (zweefTeller) {
      zweefTeller.textContent = tekst;
      zweefTeller.hidden = !n;
    }
  }

  function vliegAlles(kopers) {
    var start = aantalInMand();
    var tussen = Math.min(110, 900 / Math.max(1, kopers.length));
    var geland = 0;
    return Promise.all(kopers.map(function (koop, i) {
      return new Promise(function (wacht) { setTimeout(wacht, i * tussen); }).then(function () {
        return vliegFoto(koop, allesKnop);
      }).then(function (doel) {
        geland++;
        zetMandTeller(start + geland);
        if (doel) land(doel);
      });
    }));
  }

  if (allesKnop) {
    allesKnop.addEventListener('click', function () {
      if (allesKnop.classList.contains('is-bezig')) return;
      var items = [];
      var bij = [];
      var missend = [];
      var overgeslagen = 0;

      zichtbareKopers().forEach(function (koop) {
        var v = gekozen(koop);
        if (koop.getAttribute('data-beschikbaar') !== 'true' || v === false || (v && !v.a)) {
          overgeslagen++;
          return;
        }
        if (!v) {
          missend.push(koop);
          return;
        }
        items.push({ id: v.id, quantity: 1 });
        bij.push(koop);
      });

      if (missend.length) {
        var alleenMaat = true;
        missend.forEach(function (koop) {
          markeerOntbrekend(koop).forEach(function (k) { if (!isMaat(k)) alleenMaat = false; });
        });
        allesVraag = alleenMaat ? 'Kies nog een maat bij ' : 'Maak je keuze af bij ';
        meld(allesVraag + aantal(missend.length) + '.', true);
        missend[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!items.length) {
        meld('Er staat nu niets op de lijst dat leverbaar is.', true);
        return;
      }

      var tekst = allesKnop.textContent;
      meld('');
      knopBezig(allesKnop, 'Bezig...');
      var erbij = overgeslagen ? ' ' + aantal(overgeslagen) + ' uitverkocht, die zijn overgeslagen.' : '';

      naarWagen(items, true).then(function (data) {
        return { kopers: bij, fouten: [], data: data };
      }, function () {
        return eenVoorEen(items, bij);
      }).then(function (uitkomst) {
        var gelukt = uitkomst.kopers.length;
        if (gelukt) {
          meld(aantal(gelukt) + ' in je winkelwagen gezet.' + erbij +
            (uitkomst.fouten.length ? ' Niet gelukt: ' + uitkomst.fouten.join(' ') : ''), uitkomst.fouten.length > 0);
        } else {
          meld(uitkomst.fouten[0] || foutTekst(null), true);
        }
        knopKlaar(allesKnop, gelukt ? 'Toegevoegd' : tekst, function () { allesKnop.textContent = tekst; });
        if (!gelukt) return;
        return vliegAlles(uitkomst.kopers).then(function () {
          verversMandje(uitkomst.data);
          setTimeout(function () {
            var lade = document.getElementById('Cart-Drawer');
            if (lade && typeof lade.open === 'function') lade.open();
          }, 450);
        });
      });
    });
  }

  if (eigen) {
    document.addEventListener('verlanglijst:gewijzigd', function (e) {
      var nu = e.detail.handles;
      getoond = getoond.filter(function (h) {
        if (nu.indexOf(h) !== -1) return true;
        var kolommen = raster.querySelectorAll('[data-vl-kolom]');
        for (var i = 0; i < kolommen.length; i++) {
          if (kolommen[i].getAttribute('data-vl-kolom') === h) verwijderKolom(kolommen[i]);
        }
        return false;
      });
      var erbij = nu.filter(function (h) { return getoond.indexOf(h) === -1 && !bezig[h] && !mislukt[h]; });
      if (erbij.length) laad(erbij, true);
      if (!nu.length) setTimeout(function () { if (!handles().length) toonLeeg(true); }, 260);
      if (nu.length && ongedaan) {
        ongedaan.hidden = true;
        vorigeLijst = null;
      }
    });

    if (wisKnop) {
      wisKnop.addEventListener('click', function () {
        var lijst = lees();
        if (!lijst.length) return;
        meld('');
        bewaar([]);
        vorigeLijst = lijst;
        if (ongedaan) ongedaan.hidden = false;
        if (herstelKnop) herstelKnop.focus();
      });
    }

    if (herstelKnop) {
      herstelKnop.addEventListener('click', function () {
        if (!vorigeLijst) return;
        var terug = vorigeLijst;
        var nieuw = lees().filter(function (x) {
          return !terug.some(function (y) { return y.h === x.h; });
        });
        vorigeLijst = null;
        if (ongedaan) ongedaan.hidden = true;
        bewaar(nieuw.concat(terug));
      });
    }

    if (deelKnop) {
      deelKnop.addEventListener('click', function () {
        var lijst = lees();
        if (!lijst.length) return;
        var url = window.location.origin + paginaUrl + '?lijst=' + lijst.map(function (x) {
          return encodeURIComponent(x.h) + (x.v ? '~' + x.v : '');
        }).join(',');
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ title: 'Mijn verlanglijst bij sokkenzaak.nl', url: url }).catch(function () {});
          return;
        }
        kopieer(url).then(function () {
          meld('Link gekopieerd. Plak hem in een mail of appje.');
        }, function () {
          window.prompt('Kopieer deze link:', url);
        });
      });
    }

    var lijst = handles();
    if (!lijst.length) {
      if (laden) laden.hidden = true;
      toonLeeg(true);
    } else {
      laad(lijst, false);
    }
  } else {
    if (titel && titel.getAttribute('data-gedeeld')) titel.textContent = titel.getAttribute('data-gedeeld');
    if (intro && intro.getAttribute('data-gedeeld')) intro.textContent = intro.getAttribute('data-gedeeld');
    var leegTekst = pagina.querySelector('[data-vl-leeg-tekst]');
    if (leegTekst && leegTekst.getAttribute('data-gedeeld')) leegTekst.textContent = leegTekst.getAttribute('data-gedeeld');

    if (overneemKnop) {
      overneemKnop.addEventListener('click', function () {
        var eigenLijst = lees();
        var bestaand = eigenLijst.map(function (x) { return x.h; });
        var t = Date.now();
        var erbij = getoond
          .filter(function (h) { return bestaand.indexOf(h) === -1; })
          .map(function (h, i) {
            var item = { h: h, t: t - i };
            if (gedeeldeVarianten[h]) item.v = gedeeldeVarianten[h];
            return item;
          });
        bewaar(erbij.concat(eigenLijst));
        window.location.href = paginaUrl;
      });
    }

    if (!gedeeld.length) {
      if (laden) laden.hidden = true;
      toonLeeg(true);
    } else {
      laad(gedeeld, false);
    }
  }
})();
